import {
  AlertTriangle,
  Zap,
  Target,
  Users,
  TrendingUp,
  Brain,
  Clock,
  LucideIcon,
} from 'lucide-react'

export interface ConsequenceItem {
  icon: LucideIcon
  text: string
  sub: string
}

export interface BalancePair {
  left: string
  right: string
}

export interface RoleItem {
  icon: LucideIcon
  label: string
  humor: boolean
}

export const stuckItems = [
  'Operativa beslut som bara du kan ta',
  'Personalfrågor som alltid är brådskande',
  'Administration som aldrig tar slut',
  'Brandkårsutryckningar (igen)',
  'Styrelseförväntningar som drar åt olika håll',
]

export const needsItems = [
  'Tydligare riktning',
  'Bättre prioriteringar',
  'Högre tempo i genomförande',
  'Större ägarskap hos medarbetarna',
  'Starkare kontroll på lönsamhet och likviditet',
]

export const consequences: ConsequenceItem[] = [
  {
    icon: AlertTriangle,
    text: 'Ni blir er egen flaskhals',
    sub: 'Beslut väntar på dig. Alltid.',
  },
  {
    icon: Target,
    text: 'Strategin lever i PowerPoint',
    sub: '— men inte i vardagen.',
  },
  {
    icon: Users,
    text: 'Medarbetare väntar på beslut',
    sub: 'istället för att ta initiativ.',
  },
  {
    icon: Clock,
    text: 'Ledningsgruppen diskuterar',
    sub: 'istället för att agera.',
  },
  {
    icon: TrendingUp,
    text: 'Styrelse och ledning drar åt olika håll',
    sub: 'Ingen vinner på det.',
  },
  {
    icon: Brain,
    text: 'Du som VD är flaskhalsen',
    sub: 'Det är inte ditt fel. Men det är ditt problem.',
  },
]

export const balancePairs: BalancePair[] = [
  { left: 'Här och nu', right: 'Långsiktig riktning' },
  { left: 'Ambition', right: 'Genomförandekraft' },
  { left: 'Strategi', right: 'Kassaflöde' },
  { left: 'Tillväxt', right: 'Stabilitet' },
  { left: 'Styrelsekrav', right: 'Operativ verklighet' },
]

export const roles: RoleItem[] = [
  { icon: Target, label: 'Strategisk partner till VD/ägare', humor: false },
  {
    icon: Zap,
    label: 'Exekutiv drivkraft i prioriterade initiativ',
    humor: false,
  },
  { icon: Users, label: 'Facilitator för riktning och samsyn', humor: false },
  { icon: Brain, label: 'Avlastning i det som blockerar', humor: false },
  {
    icon: TrendingUp,
    label: 'Kopplingen mellan strategi och ekonomi',
    humor: false,
  },
]

export const workPrinciples = [
  'Vi identifierar de verkliga hindren — inte symptomen',
  'Vi prioriterar hårt (och säger nej till det som inte spelar roll)',
  'Vi skapar tydligt ansvar och mandat',
  'Vi arbetar iterativt med lärandeloopar',
  'Vi kopplar beslut till faktiska ekonomiska konsekvenser',
]

export const ctaPersonas = [
  {
    icon: Target,
    title: 'VD',
    text: 'Du leder bolaget men fastnar i det operativa.',
  },
  {
    icon: Users,
    title: 'Ägare',
    text: 'Du vill ta nästa steg men saknar rätt drivkrafter.',
  },
  {
    icon: Brain,
    title: 'Chef',
    text: 'Du behöver avlastning för att kunna leda på riktigt.',
  },
  {
    icon: TrendingUp,
    title: 'Ledningsgrupp',
    text: 'Ni diskuterar mycket men vill öka takten.',
  },
]
